export enum EconomicOperatorDefaultAttributes {
  ManufacturerUID = "35588438-a503-40ee-b985-d92c3068f591",
  ManufacturerName = "7210c831-f050-4bed-82ef-f4f540a0d967",
  Address1 = "0360cc1e-80de-49e9-a11a-f55513b0c1f3",
  Address2 = "133207ed-e758-4266-ad0f-6deef3a8e8a9",
  ZipCode = "38c08125-1810-4fde-998c-9640ea08d070",
  City = "1660db8d-ee7d-4704-9f39-5fe90af905d0",
  Country = "42c94944-7b4e-4fd3-95c6-df76932589fc",
  Phone = "6bc7a95d-ef23-4e67-a7ad-95844727b726",
  Email = "25acb70d-32e0-4b8b-920c-a8454bd45413",
  Website = "4c6a0ad3-c8b7-448a-8c0b-c11ee43236d4",
  CustomText1 = "9438c6ed-b788-4526-9d27-e593e55c4cb4",
  CustomText2 = "03d335ea-fe0d-46d0-873d-8d5044c3ebe6",
  CustomText3 = "3da4b554-60ac-4842-b077-374305bb0303",
  CustomMediaAsset1 = "559bf6a4-ad77-4ebb-b02e-70d3b9ecbe73",
  CustomMediaAsset2 = "4cfc4e44-9e22-4287-a872-c651275449fe",
  CustomMediaAsset3 = "da586ff9-51d6-4cf1-9bf8-488b6f7bee79"
}
